import React, { useMemo } from 'react'
import { cartMobx, storeMobx, restaurantConfig } from 'restaurant'
import { themeMobx, memberMobx } from '@mobxStore'
import { classNames, getParams } from '@dt/fe-utils'
import { useHistoryNew, getPlatform, alertLayer } from '@utils'
import { thirdConfigG } from 'controllers/third'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
  data: IEntrySetting;
}

const Entrance: React.FC<IProps> = (props) => {
  const { entries, backgroundColor, textColor, backgroundColorAlpha } = props.data
  const { style = `row${entries?.length}` } = props.data
  const history = useHistoryNew()

  const entranceStyle = useMemo(() => {
    return {
      '--dr-entry-back-color': backgroundColor,
      '--dr-entry-text-color': textColor,
      paddingTop: '1px'
    }
  }, [props.data])

  const _handleScan = () => {
    thirdConfigG().scan(str => {
      if (str) {
        const { ct, b, s, t } = getParams({ url: str })
        if (!!ct && !!b && !!s && ((!!t && ct === 'table') || ct === 'store') && Number(b) === Config.BRANDID) {
          location.replace(str)
        } else {
          alertLayer(i18n.t('menu.scanCodeTip'))
        }
      }
    })
  }

  // 入口跳转
  const handleGoEntry = function (type: TEntryType, info?: any) {
    if (['togo', 'dinein', 'pickup', 'delivery', 'buyTogether'].includes(type)) {
      if (type === 'buyTogether') {
        cartMobx.setEatType((storeMobx.hasDeliveryStoreAndBuyTogether ? 'delivery' : 'togo') as TEatType)
      } else {
        cartMobx.setEatType(type as TEatType)
      }
      const inStore = restaurantConfig.storeId || (restaurantConfig?.lbs?.lat && restaurantConfig?.lbs?.lng)
      const tt = type === 'buyTogether' ? 'buyTogether' : 'homeEntry'
      if (inStore) {
        history.push('/menu', null, { tt, et: type })
      } else {
        history.push('/store', null, { tt, et: type })
      }
    } else if (type === 'order') {
      history.push('/menu')
    } else if (type === 'scancode') {
      const { isWeixin, isAlipay } = getPlatform()
      if (Config.codeType === 'brand' && (isWeixin || isAlipay)) {
        if (isAlipay) {
          thirdConfigG().init(() => {
            _handleScan()
          })
        } else {
          _handleScan()
        }
      }
    } else if (type === 'orders') {
      const ordersTab = themeMobx.showTabs?.find(item => item.type === 'orders')
      history.push(ordersTab ? '/orders' : '/orders/2')
    } else if (type === 'member') {
      history.push('/my')
    } else if (type === 'mall') {
      history.push('/mall')
    } else if (type === 'coupon') {
      history.push('/iCoupon')
    } else if (type === 'integralRedeem') {
      history.push('/redeem')
    } else if (type === 'product') {
      history.push(`/recommend/${type}/${info.uid}/${info.productTitle}`)
    } else if (type === 'memberCard') {
      let url = '/memberCard'
      if (info && info.cardId) {
        const hasItem: any = memberMobx.cardList.find((m: any) => m.cardId === info.cardId)
        if (hasItem) {
          const cardInfo = hasItem.card
          if (cardInfo.type === 'paid' && cardInfo.scales.length > 0 && hasItem.expireTime) {
            url = '/iCard/cardOpen/buy/' + hasItem.memberCardId
          } else if ((cardInfo.allowAgainLoad && cardInfo.recharges.length > 0) || cardInfo.allowCustomizeLoad) {
            url = '/iCard/cardRecharge/' + hasItem.memberCardId
          } else {
            url = '/iCard/' + hasItem.cardId
          }
        } else {
          url = '/iCard/cardOpen/open/' + info.cardId
        }
      }
      history.push(url)
    } else if (type === 'giftCard') {
      if (info?.cardId) {
        const hasItem: any = memberMobx.giftCardList.find((m: any) => m.giftcardId === info.cardId && m.status === 'enable')
        if (hasItem && hasItem.giftcard.allowAgainLoad) {
          history.push(`/iGc/recharge/${hasItem.memberCardId}`)
        } else {
          history.push(`/giftCard/buy/${info.cardId}`)
        }
      } else {
        history.push('/giftCard/2')
      }
    } else if (type === 'groupBuy') {
      history.push('/groupBuy')
    } else if (type === 'activityReserve') {
      history.push('/activityReserve')
    }
  }

  const rowItem = (entry: IEntry[] = []) => {
    const { isWeixinMiniProgram } = getPlatform()
    return (
      <>
        {
          entry.map(({ type, name, icon = '', pic = '', subName, mode, extra }, index) => {
            const realIcon = icon.indexOf('entry') <= -1 ? `entry-${icon}` : icon
            if (type === 'buyTogether' && !(bo === 'cn' && !Config.buyTogetherId && isWeixinMiniProgram && Config.codeType === 'brand')) {
              return null
            }
            if (/decorate\./.test(name)) {
              name = ''
            }
            return (
              <div
                data-cypid='homeEntryItem'
                key={index}
                className={classNames('entrance-item', { 'no-shadow': backgroundColorAlpha === 0 })}
                onClick={() => handleGoEntry(type, extra)}
              >
                <div className='entrance-item-bg' style={{ opacity: backgroundColorAlpha }}></div>
                <div className={style === 'row2' ? 'entrance-content-rowtow' : style === 'row3' ? 'entrance-content-rowthree' : 'entrance-item-content'}>
                  {mode === 0 ? <Icon icon='dicon' name={String(realIcon)} /> : <img src={pic} />}
                  <div className='entrance-info'>
                    <p className='entry-name'>{name || i18n.t(`entry.${type}`)}</p>
                    {subName && <small className='entry-sub-name'>{subName}</small>}
                  </div>
                </div>
              </div>
            )
          })
        }
      </>
    )
  }

  return (
    <>
      {
        style?.includes('pin') ? (
          (
            <div style={entranceStyle}>
              <div className={`entrance-wrapper ${style?.includes('dpin') ? `row row${entries.length - 1}` : 'column'}`}>
                {
                  rowItem(entries.slice(0, style?.includes('dpin') ? (entries.length - 1) : 1) || [])
                }
              </div>
              <div className={`entrance-wrapper ${style?.includes('dpin') ? 'column' : `row row${entries.length - 1}`}`}>
                {
                  rowItem(entries.slice(style?.includes('dpin') ? (entries.length - 1) : 1) || [])
                }
              </div>
            </div>
          )
        ) : (
          <div style={entranceStyle}>
            <div className={`entrance-wrapper ${style?.slice(0, -1)} ${style === 'row2' ? 'rowtow' : style === 'row3' ? 'rowthree' : style?.slice(0, -1) === 'row' ? style : ''}`}>
              {rowItem(entries)}
            </div>
          </div>
        )
      }
    </>
  )
}

export default Entrance
